const HEADER_HEIGHT = 74

export const isVisible = (domElement) => {
    const rect = domElement.getBoundingClientRect()

    const inViewportVertically =
        rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
        rect.bottom > HEADER_HEIGHT

    const inViewportHorizontally =
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.right > 0

    return inViewportVertically && inViewportHorizontally
}